import {Component, OnInit} from '@angular/core';
import {AppEventService} from './common/_services/event-broadcaster.service';
import {UtilService} from './common/_services/util.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{

    ai_id: number;
    app_name: string;
    qualifier = [];
    category = [];
    format = [];
    location = [];
    occupation = [];
    gender = [];
    age_group = [];
    handlers = [];
    tags = [];

    properties;

    ngOnInit(): void {
        localStorage.clear();
    }


}



